import { printHtml } from "./shelfPrint";

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmtNum = (n) => Math.round(Number(n) || 0).toLocaleString();

export const buildInventoryHtml = (groups, title = "Component Inventory") => {
  const hasTruck = groups.some((g) => g.rows.some((r) => r.truckloads !== undefined));
  const sections = groups
    .map(
      (g) => `
  <div class="grp">
    <div class="grphdr">${esc(g.name)}</div>
    <table>
      <thead><tr><th>Variant</th><th class="r">Units in Stock</th><th class="r">Reserved</th><th class="r">Available</th>${hasTruck ? '<th class="r">Truckloads Supported</th>' : ""}</tr></thead>
      <tbody>
        ${g.rows
          .map(
            (r) =>
              `<tr><td>${esc(r.name)}</td><td class="r">${esc(r.stockText)}</td><td class="r">${fmtNum(r.reserved)}</td><td class="r${r.avail < 0 ? " neg" : ""}">${fmtNum(r.avail)}</td>${hasTruck ? `<td class="r">${esc(r.truckloads ?? "—")}</td>` : ""}</tr>`
          )
          .join("")}
      </tbody>
    </table>
  </div>`
    )
    .join("");
  return `<html><head><title>${esc(title)}</title><style>
    * { box-sizing: border-box; }
    body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #0f172a; margin: 24px; }
    h1 { font-size: 20px; margin: 0 0 2px; letter-spacing: -0.02em; }
    .sub { font-size: 11px; color: #64748b; margin-bottom: 18px; }
    .grp { margin-bottom: 16px; break-inside: avoid; }
    .grphdr { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #002FA7; border-bottom: 2px solid #002FA7; padding-bottom: 3px; margin-bottom: 4px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th { text-align: left; font-size: 9px; text-transform: uppercase; letter-spacing: 0.06em; color: #64748b; padding: 3px 6px; border-bottom: 1px solid #e2e8f0; }
    td { padding: 4px 6px; border-bottom: 1px solid #f1f5f9; font-variant-numeric: tabular-nums; }
    .r { text-align: right; }
    .neg { color: #dc2626; font-weight: 600; }
    @media print { body { margin: 10mm; } }
  </style></head><body>
    <h1>${esc(title)}</h1>
    <div class="sub">Replenish Supply · Printed ${new Date().toLocaleString()}</div>
    ${sections}
  </body></html>`;
};

export const printInventoryReport = (groups, title) => printHtml(buildInventoryHtml(groups, title));
